import './config';
import { apiBaseUrl }    from './config';
import { getBaseHeader } from './utils';
import SfpBaseService    from './sfp-base-service';
import Instruction       from '../../model/instruction';
import Chapter           from '../../model/chapter';

const INSTRUCTIONS = 'instructions';
const CHAPTERS = 'chapters';

export default class ChaptersService extends SfpBaseService {

  /**
   * @param {Instruction} instruction 
   */
  static findChaptersByInstruction(instruction) {
    return fetch(`${apiBaseUrl}/${INSTRUCTIONS}/${instruction.id}/${CHAPTERS}`, {headers: getBaseHeader()})
      .then(super.returnResponse);
  }

  /**
   * @param {Instruction} instruction 
   * @param {Chapter}     chapter 
   */
  static createChapter(instruction, chapter) {
    const body = {
      chapter: {
        number: chapter.number,
        label : chapter.label
      }
    };
    const headers = {
      ...getBaseHeader(),
      'Content-Type': 'application/json'
    };

    return fetch(`${apiBaseUrl}/${INSTRUCTIONS}/${instruction.id}/${CHAPTERS}`, {body, headers})
      .then(super.returnResponse);
  }

  /**
   * @param {Instruction} instruction 
   * @param {Number}      chapterId 
   */
  static findChapterById(instruction, chapterId) {
    return fetch(`${apiBaseUrl}/${INSTRUCTIONS}/${instruction.id}/${CHAPTERS}/${chapterId}`, {headers: getBaseHeader()})
      .then(super.returnResponse);
  }
}


// WEBPACK FOOTER //
// ./src/service/sfp/chapters-service.js